import styles from "./TourViewer.module.css";

export default function TourLoadOverlay({
  visible,
  imageUrl,
  label = "Loading 360 tour",
}) {
  return (
    <div
      className={`${styles.loadOverlay} ${visible ? styles.loadOverlayVisible : ""}`}
      aria-hidden={!visible}
    >
      <div className={styles.loadCard}>
        {imageUrl && (
          <div className={styles.loadPreviewWrap}>
            <img
              src={imageUrl}
              alt=""
              className={styles.loadPreview}
              decoding="async"
            />
          </div>
        )}
        <p className={styles.loadLabel}>{label}</p>
        <div className={styles.loadTrack} aria-hidden>
          <div className={styles.loadFill} />
        </div>
      </div>
    </div>
  );
}
